import {Component, OnDestroy, OnInit} from '@angular/core';
import {MinimumCommModel} from '../../../../models/MinimumCommModel';
import {Subscription} from 'rxjs';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {MinimumCommService} from '../service-minimum-comm/minimum-comm.service';
import {LoaderService} from '../../../general-services/service-loader/loader.service';
import {NumAnnoMeseService} from '../../../general-services/service-num-anno-mese/num-anno-mese.service';
import * as toastr from 'toastr';
import {ProviderModel} from '../../../../models/ProviderModel';
import {BaseGeneralComponent} from '../../../BaseGeneralComponent';

@Component({
  selector: 'app-edit-minimum-comm',
  templateUrl: './edit-minimum-comm.component.html',
  styleUrls: ['./edit-minimum-comm.component.scss']
})
export class EditMinimumCommComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  showActions: boolean;
  providerSelect: ProviderModel;

  registerForm: FormGroup;
  submitted = false;

  allYear: any;
  minimumCommJson: any;
  minimumComm: MinimumCommModel;

  getPageSubscribe: Subscription;
  parameterSubscribe: Subscription;
  saveMinimumComm: Subscription;

  constructor(private route: ActivatedRoute, private router: Router,
              private minimumCommService: MinimumCommService,
              private formBuilder: FormBuilder,
              private loaderService: LoaderService,
              private annoMeseService: NumAnnoMeseService) {
    super();

    this.showActions = false;
    this.providerSelect = new ProviderModel();
  }

  ngOnInit() {
    this.parameterSubscribe = this.route
      .queryParams
      .subscribe(params => {
        this.minimumCommJson = params['row'];
        this.minimumComm = JSON.parse(this.minimumCommJson) as MinimumCommModel;
        this.providerSelect = this.minimumComm.provider;
      });

    this.registerForm = this.formBuilder.group({
      provider: [{value: '', disabled: false}, Validators.required],
      year: [{value: '', disabled: false}, Validators.required],
      value: [{value: '', disabled: false}, Validators.required]
    });

    this.registerForm.patchValue({
      provider: this.providerSelect.cod
    });

    this.registerForm.patchValue({
      year: this.minimumComm ? this.minimumComm.anno : ''
    });

    this.registerForm.patchValue({
      value: this.minimumComm ? this.minimumComm.value : ''
    });

    this.getAllYear();
  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.CONTRACTUAL_DATA], {queryParams: {selectedIndex: 2}});
  }

  save() {
    this.submitted = true;
    if (this.registerForm.valid) {
      this.minimumComm.anno = this.registerForm.value.year;
      this.minimumComm.value = this.registerForm.value.value;
      event.preventDefault();
      this.loaderService.display(true);
      this.saveMinimumComm = this.minimumCommService.update(this.minimumCommService.baseUrl, this.minimumComm)
        .subscribe(
          (result: any) => {
            if (result === -1) {
              toastr.options.timeout = 5000;
              toastr.warning('Duplicate item, cannot be created', 'Warning');
              this.loaderService.display(false);
            } else {
              toastr.success('Minimum Commitment was created with success', 'Success');
              this.loaderService.display(false);
              this.router.navigate([this.LINKS.CONTRACTUAL_DATA], {queryParams: {selectedIndex: 2}});
            }
          },
          error => {
            toastr.error('Minimum Commitment was not created', 'Error');
            this.loaderService.display(false);
          });
    }
  }

  ngOnDestroy(): void {
    if (this.saveMinimumComm) {
      this.saveMinimumComm.unsubscribe();
    }
  }

  handle(value) {
    this.minimumComm.anno = value;
    this.registerForm.patchValue({
      anno: value
    });
  }

  getElementSelectedProvider($event) {
    this.minimumComm.provider = $event.row;
    this.providerSelect = $event.row;
    this.registerForm.patchValue({
      provider: this.providerSelect.cod
    });
  }

  // convenience getter for easy access to form fields
  get f() { return this.registerForm.controls; }

  getAllYear() {
    this.getPageSubscribe = this.annoMeseService.getAllYear()
      .subscribe(
        (result: any) => {
          this.allYear = result;
        });
  }

  reset() {
    this.registerForm.patchValue({
      year: null,
      value: null
    });

  }
}
